var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('h3',[_vm._v("LI BEIRUT action day")])]),_c('li-beirut-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }